import { b as __assign } from './tslib.es6-e24bb3a5.js';
import React from 'react';
import ReactDOM from 'react-dom';
import MatomoTracker from '@datapunt/matomo-tracker-js';
import * as Sentry from '@sentry/react';

var matomoHost = 'https://analytics.10bshop.com';
Sentry.init({
  dsn: 'https://f42a2301702e4de195c0fe9f65622959@o551754.ingest.sentry.io/5675472'
});

function render(component, props, matomoId, element) {
  var tracker = new MatomoTracker({
    urlBase: matomoHost,
    siteId: matomoId
  });
  tracker.trackPageView();
  var Component = React.createElement(component, __assign(__assign({}, props), {
    tracker: tracker
  }));
  ReactDOM.render(Component, element);
}

export default render;
